import React from "react";
import { RadioGroup, Switch } from "@my-scoot/component-library-legacy";
import {
  SELECTION_METHOD,
  SELECTION_METHOD_OPTIONS,
} from "../utils/unifiedOffer";
import { useOffersSurgeSettingsStore } from "../store/useOffersSurgeSettingsStore";
import { ExlyModal } from "features/Common/modules/ExlyModal/ExlyModal";

/**
 * Offers & Surge Pricing Settings (§4.7). Per-offering master switch +
 * selection method. Persists in offering metadata until backend API exists.
 */
const OffersSurgeSettingsModal = ({ onSave, onReset, saving = false }) => {
  const {
    open,
    setOpen,
    masterEnabled,
    setMasterEnabled,
    selectionMethod,
    setSelectionMethod,
  } = useOffersSurgeSettingsStore();

  const selectedMethod =
    SELECTION_METHOD_OPTIONS.find((opt) => opt.value === selectionMethod) ||
    SELECTION_METHOD_OPTIONS[0];

  return (
    <ExlyModal
      open={open}
      onClose={() => setOpen(false)}
      title="Offers & Surge Pricing Settings"
      primaryBtnText="Save details"
      primaryBtnProps={{ disabled: saving, loading: saving }}
      secondaryBtnText="Cancel"
      onSecondaryBtnClick={() => setOpen(false)}
      onPrimaryBtnClick={() => {
        if (onSave) onSave({ masterEnabled, selectionMethod });
        setOpen(false);
      }}
    >
      <div className="tw-py-4 tw-min-w-[400px]">
        <div className="tw-flex tw-items-center tw-justify-between tw-rounded-lg tw-border tw-border-solid tw-border-gray-200 tw-p-3">
          <div>
            <p className="tw-font-medium tw-text-[14px]">
              Offers & surge pricing
            </p>
            <p className="tw-text-[12px] tw-text-gray-500">
              {masterEnabled
                ? "All discount and surge rules on this offering are running."
                : "Paused — customers see the plain listed price."}
            </p>
          </div>
          <Switch
            checked={masterEnabled}
            size="large"
            color="success"
            onChange={(_event, checked) => setMasterEnabled(checked)}
          />
        </div>

        <div className={masterEnabled ? "tw-mt-3" : "tw-mt-3 tw-opacity-50"}>
          <p className="tw-font-medium tw-text-[13px] tw-mb-2">
            If more than one offer/surge could apply, which one?
          </p>
          <div className="tw-my-2">
            <RadioGroup
              options={SELECTION_METHOD_OPTIONS.map((opt) => ({
                label: opt.label,
                value: opt.value,
              }))}
              selected={{
                label: selectedMethod.label,
                value: selectedMethod.value,
              }}
              onChange={({ value }) => setSelectionMethod(value)}
              // RadioGroup has no top-level disabled prop — radioProps fans
              // out onto each Radio, so selection can't change while paused.
              radioProps={{ disabled: !masterEnabled }}
            />
          </div>
          <p className="tw-mt-2 tw-text-[12px] tw-text-gray-500">
            {selectedMethod.value === SELECTION_METHOD.LOWEST && (
              <span className="tw-mr-2 tw-rounded-full tw-bg-green-100 tw-px-2 tw-py-0.5 tw-text-[11px] tw-text-green-800">
                Recommended
              </span>
            )}
            {selectedMethod.description}
          </p>
          {!masterEnabled && (
            <p className="tw-mt-2 tw-text-[12px] tw-text-gray-500">
              Selection is not in effect while everything is paused.
            </p>
          )}
          {onReset && (
            <button
              type="button"
              disabled={saving}
              onClick={onReset}
              className="tw-mt-3 tw-text-[13px] tw-font-medium tw-text-purple-700 hover:tw-underline disabled:tw-opacity-40"
            >
              Reset this offering to account settings
            </button>
          )}
        </div>
      </div>
    </ExlyModal>
  );
};

export { OffersSurgeSettingsModal };
